// Pixabay API configuration
const PIXABAY_API_KEY = '51269013-db0ab27aa0bd02c1c87df7d88';
const PIXABAY_API_URL = 'https://pixabay.com/api/';

export interface PixabayImage {
  id: number;
  pageURL: string;
  type: string;
  tags: string;
  previewURL: string;
  previewWidth: number;
  previewHeight: number;
  webformatURL: string;
  webformatWidth: number;
  webformatHeight: number;
  largeImageURL: string;
  imageWidth: number;
  imageHeight: number;
  imageSize: number;
  views: number;
  downloads: number;
  collections: number;
  likes: number;
  comments: number;
  user_id: number;
  user: string;
  userImageURL: string;
}

export interface PixabaySearchResult {
  total: number;
  totalHits: number;
  hits: PixabayImage[];
}

export async function searchPixabayImages(
  query: string,
  options: {
    imageType?: 'all' | 'photo' | 'illustration' | 'vector';
    orientation?: 'all' | 'horizontal' | 'vertical';
    category?: string;
    perPage?: number;
    page?: number;
    safeSearch?: boolean;
    language?: 'en' | 'ko';
  } = {}
): Promise<PixabaySearchResult> {
  const {
    imageType = 'photo',
    orientation = 'horizontal',
    category = '',
    perPage = 20,
    page = 1,
    safeSearch = true,
    language = 'en'
  } = options;

  const params = new URLSearchParams({
    key: PIXABAY_API_KEY,
    q: encodeURIComponent(query),
    image_type: imageType,
    orientation: orientation,
    category: category,
    per_page: perPage.toString(),
    page: page.toString(),
    safesearch: safeSearch.toString(),
    lang: language
  });

  try {
    const response = await fetch(`${PIXABAY_API_URL}?${params}`);
    if (!response.ok) {
      throw new Error(`Pixabay API error: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    return data as PixabaySearchResult;
  } catch (error) {
    console.error('Failed to search Pixabay images:', error);
    throw error;
  }
}

// Helper function to get a direct image URL for slide backgrounds
export function getPixabayImageUrl(image: PixabayImage, size: 'preview' | 'web' | 'large' = 'large'): string {
  switch (size) {
    case 'preview':
      return image.previewURL;
    case 'web':
      return image.webformatURL;
    case 'large':
    default:
      return image.largeImageURL;
  }
}